const defaultLocale = "en"

const i18nPath = {
  it: {
    category: "categoria",
    search: "cerca",
    privacy: "12347606",
    cookie: "cookie-policy",
  },
  en: {
    category: "category",
    search: "search",
    privacy: "75986341",
    cookie: "cookie-policy",
  },
  he: {
    category: "category",
    search: "search",
    privacy: "75986341",
    cookie: "cookie-policy",
  },
  es: {
    category: "category",
    search: "search",
    privacy: "85595849",
    cookie: "cookie-policy",
  },
  de: {
    category: "category",
    search: "search",
    privacy: "10508834",
    cookie: "cookie-policy",
  },
  pt: {
    category: "category",
    search: "search",
    privacy: "12807869",
    cookie: "cookie-policy",
  },
  pl: {
    category: "category",
    search: "search",
    privacy: "78735194",
    cookie: "cookie-policy",
  },
  ru: {
    category: "category",
    search: "search",
    privacy: "93944681",
    cookie: "cookie-policy",
  },
  "en-us": {
    category: "category",
    search: "search",
    privacy: "95114057",
    cookie: "cookie-policy",
  },
  "en-ca": {
    category: "category",
    search: "search",
    privacy: "95114057",
    cookie: "cookie-policy",
  },
  fr: {
    category: "category",
    search: "search",
    privacy: "24908168",
    cookie: "cookie-policy",
  },
  el: {
    category: "category",
    search: "search",
    privacy: "61562393",
    cookie: "cookie-policy",
  },
}

export function getPagePath(page, locale) {
  const pageLocale = locale || page.locale
  let lang =
    pageLocale === defaultLocale ? "/" : `/${pageLocale.toLowerCase()}/`
  let path = page._allSlugLocales.find(x => x.locale === pageLocale)
    ? `${page._allSlugLocales.find(x => x.locale === pageLocale).value}`
    : null
  if (page.root || !page.treeParent) {
    return lang + `${path}/`
  }
  path = `${
    page.treeParent._allSlugLocales.find(x => x.locale === pageLocale)
      ? page.treeParent._allSlugLocales.find(x => x.locale === pageLocale).value
      : null
  }/${path}`
  if (page.treeParent.root) {
    return lang + `${path}/`
  }
  path = `${
    page.treeParent.treeParent._allSlugLocales.find(
      x => x.locale === pageLocale
    ).value
  }/${path}`
  return lang + `${path}/`
}

export function getHomePath(locale, value) {
  const localePrefix =
    locale === defaultLocale ? "" : `/${locale.toLowerCase()}`
  const isDefaultPath = !value || value === "home"
  return isDefaultPath ? `${localePrefix}/` : `${localePrefix}/${value}/`
}

export function getSearchPath(locale) {
  const localeKey = locale.toLowerCase()
  const searchPath = i18nPath[localeKey]?.search || 'search'
  return locale === defaultLocale
    ? `/${searchPath}/`
    : `/${localeKey}/${searchPath}/`
}

export function getPrivacyPath(locale) {
  return `https://www.iubenda.com/privacy-policy/${i18nPath[locale.toLowerCase()].privacy}`
}

export function getCookiePath(locale) {
  return `https://www.iubenda.com/privacy-policy/${i18nPath[locale.toLowerCase()].privacy}/cookie-policy`
}

export function getBlogPath(locale) {
  return locale === defaultLocale ? `/news/` : `/${locale.toLowerCase()}/news/`
}

export function getFeaturedEventPath(page, locale) {
  return locale === defaultLocale
    ? `/${locale.toLowerCase()}/${page.slug}/`
    : `/${locale.toLowerCase()}/${page.slug}/`
}

export function getArticleCategoryPath(page, locale) {
  const localeKey = locale.toLowerCase()
  const categoryPath = i18nPath[localeKey]?.category || 'category'
  return locale === defaultLocale
    ? `/news/${categoryPath}/${
        page._allSlugLocales.find(x => x.locale === locale)
          ? page._allSlugLocales.find(x => x.locale === locale).value
          : null
      }/`
    : `/${localeKey}/news/${categoryPath}/${
        page._allSlugLocales.find(x => x.locale === locale)
          ? page._allSlugLocales.find(x => x.locale === locale).value
          : null
      }/`
}

export function getArticlePath(page, locale) {
  return locale === defaultLocale
    ? `/news/${
        page._allSlugLocales.find(x => x.locale === locale)
          ? page._allSlugLocales.find(x => x.locale === locale).value
          : null
      }/`
    : `/${locale.toLowerCase()}/news/${
        page._allSlugLocales.find(x => x.locale === locale)
          ? page._allSlugLocales.find(x => x.locale === locale).value
          : null
      }/`
}

export function getStoriesPath(locale) {
  return locale === defaultLocale
    ? `/stories/`
    : `/${locale.toLowerCase()}/stories/`
}

export function getStoryCategoryPath(page, locale) {
  const localeKey = locale.toLowerCase()
  const categoryPath = i18nPath[localeKey]?.category || 'category'
  return locale === defaultLocale
    ? `/stories/${categoryPath}/${
        page._allSlugLocales.find(x => x.locale === locale)
          ? page._allSlugLocales.find(x => x.locale === locale).value
          : null
      }/`
    : `/${localeKey}/stories/${categoryPath}/${
        page._allSlugLocales.find(x => x.locale === locale)
          ? page._allSlugLocales.find(x => x.locale === locale).value
          : null
      }/`
}

export function getStoryPath(page, locale) {
  return locale === defaultLocale
    ? `/stories/${
        page._allSlugLocales.find(x => x.locale === locale)
          ? page._allSlugLocales.find(x => x.locale === locale).value
          : null
      }/`
    : `/${locale.toLowerCase()}/stories/${
        page._allSlugLocales.find(x => x.locale === locale)
          ? page._allSlugLocales.find(x => x.locale === locale).value
          : null
      }/`
}
